(function($, _) {
  var ns = window.nspace("ccc.viz.map.views");

  /**
   * Figures out which legend range this data point falls into
   */
  function findThemeColor(dataPoint, ranges, largerValuesAre) {
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i];
      var min = parseFloat(range.minValue);
      var max = parseFloat(range.maxValue);
      var dp = parseFloat(dataPoint);

      // Assumes non-continuous legend breaks
      if (min <= dp && max >= dp) {
        break;
      }
    }

    if (i >= ranges.length) {
      i = ranges.length - 1;
    }

    var themeColors = ccc.viz.map.config.MapConfig.themeColors.slice();

    if (largerValuesAre == "worse" || largerValuesAre == "neutral") {
      return themeColors.reverse()[i].color;
    }
    else {
      return themeColors[i].color;
    }
  }

  /**
   * Displays a popup with a data point when mouse is hovering over a location
   */
  ns.MapPopupView = Backbone.View.extend({
    el: "#map-popup-container",
    templateSelector: "#map-popup-template",
    name: "Map Popup",

    initialize: function(options) {
      _.bindAll(this, "showPopup", "hidePopup", "loadTemplate");

      this.selectorsModel = options.selectorsModel;

      this.dispatcher = options.dispatcher;
      this.dispatcher.on("mouseoff-region", this.hidePopup);
      this.dispatcher.on("mouseover-region", this.showPopup);

      this.offset = {
        x: 0,
        y: 30
      };
    },

    loadTemplate: function() {
      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }
    },

    /**
     * Hides the map popup
     */
    hidePopup: function(args) {
      this.$el.hide();
    },

    /**
     * Displays the map popup
     */
    showPopup: function(args) {
      this.loadTemplate();

      var self = this;

      // Get the data to display
      var fips = args.fips;
      $.when(this.model.getDataResponse()).done(function() {
        var response = self.model.get("response");
        var tfId = self.selectorsModel.get("timeFrameId");
        var allYearsData = response.dataByFips[fips];
        var data = !allYearsData
          ? null
          : _.find(allYearsData, function(yearData) {
            return yearData.timeFrameId === tfId;
          });

        var location = response.locationsByFips[fips];

        var largerValuesAre = response.largerValuesAre;

        // Defaults
        var templateData = {
          name: "Location",
          text: "No Data",
          swatchColor: "#fff",
          rank: ""
        };

        // Fill out the actual values
        if (location) {
          templateData.name = location.name;

		  if (location.isUninhabited) {
			templateData.text = "Area is uninhabited";
			templateData.swatchColor = "gray";
		  }
        }

        if (data) {
          templateData.text = data.displayValue;
          templateData.swatchColor = findThemeColor(
            data.value,
            response.ranges,
            largerValuesAre
          );
          templateData.rank = _.str.isBlank(data.rank)
            ? ""
            : "Ranks " + data.rank;
        }

        // Rerender the popup contents
        var html = self.template(templateData);
        self.$el.html(html);

        // Reposition the popup
        var pixels = ccc.viz.map.util.MapUtil.fromPositionToRelativePixels(
          args.gmap,
          args.latLng
        );

        // Move left/right/up/down based on the configured offset
        pixels.x += self.offset.x;
        pixels.y += self.offset.y;

        // Move west by half the width of the popup in order to center it under cursor
        pixels.x -= self.$el.outerWidth() / 2;

        // Set the position
        self.$el.css({
          left: pixels.x,
          top: pixels.y
        });

        // Quick fade in
        self.$el.stop(true, true).fadeIn(200);
      });
    }
  });
})(jQuery, _);
